import { render, staticRenderFns } from "./Color.vue?vue&type=template&id=74153d8a&scoped=true&"
import script from "./Color.vue?vue&type=script&lang=ts&"
export * from "./Color.vue?vue&type=script&lang=ts&"
import style0 from "./Color.vue?vue&type=style&index=0&id=74153d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74153d8a",
  null
  
)

export default component.exports